const { accreditationAnswerMap } = require('buyside/util/constantsFromRails.json');

export const generateRadios = (name: string): { value: string; label: string }[] =>
  accreditationAnswerMap[name as keyof typeof accreditationAnswerMap].map((answer: any) => ({
    label: answer,
    value: answer
  }));
